
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon16Screenshot = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .438)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.718 5.718H16V16H5.718z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.084 14.094h-6.45a.644.644 0 0 1-.645-.644V8.945c0-.356.289-.644.645-.644h1.29l.645-.965h2.58l.645.965h1.29c.356 0 .645.288.645.644v4.505a.644.644 0 0 1-.645.644z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 10.859,
  cy: 11.032,
  r: 1.444
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14.787v14.787H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.704 2.773h2.31v2.31m-6.931 6.931h-2.31v-2.31m0-4.621v-2.31h2.31"
}))));

      const __svgRaw = "<svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g transform=\"translate(0 .438)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M5.718 5.718H16V16H5.718z\"/>\r\n        <path d=\"M14.084 14.094h-6.45a.644.644 0 0 1-.645-.644V8.945c0-.356.289-.644.645-.644h1.29l.645-.965h2.58l.645.965h1.29c.356 0 .645.288.645.644v4.505a.644.644 0 0 1-.645.644z\" stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        <circle stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" cx=\"10.859\" cy=\"11.032\" r=\"1.444\"/>\r\n        <path d=\"M0 0h14.787v14.787H0z\"/>\r\n        <path stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.704 2.773h2.31v2.31M5.083 12.014h-2.31v-2.31M2.773 5.083v-2.31h2.31\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-16-screenshot.fed5da6ea28a0762e9b4f3169c0156c9.svg"),
        {
          React: SvgIcon16Screenshot,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      